import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomePage from '@/views/HomePage.vue'
import LogIn from '@/views/LogIn.vue'
import MessageBox from '@/views/MessageBox.vue'
import MisFormularios from '@/views/Formularios/MisFormularios.vue'
import CrearFormulario from '@/views/Formularios/CrearFormulario.vue'
import EditFormulario from '@/views/Formularios/EditFormulario.vue'
import CompletarFormulario from '@/views/Formularios/CompletarFormulario.vue'
import ResponderFormulario from '@/views/Formularios/ResponderFormulario.vue'
import VerFormulario from '@/views/Formularios/VerFormulario.vue'
import OmekaPage from '@/views/Embebidos/OmekaPage.vue'
import PersonasPage from '@/views/Personas/PersonasPage.vue'
import BeneficiosPage from '@/views/BeneficiosPage.vue'
import GaleriaPage from '@/views/GaleriasPage.vue'
import VerPerfil from '@/views/VerPerfil.vue'
import VerDatosPersona from '@/views/Personas/VerDatosPersona.vue'
import EditarRoles from '@/views/Personas/EditarRoles.vue'
import CrearRoles from '@/views/Personas/CrearRoles.vue'
import ExportadoresPage from '@/views/ExportadoresPage.vue'
import AutorizarFormulario from '@/views/Formularios/AutorizarFormulario.vue'
import ResultadosAcademicos from '@/views/Embebidos/ResultadosAcademicos.vue'
import MenuPage from '@/views/MenuPage.vue'
import AgregarPersona from '@/views/Personas/AgregarPersona.vue'
import EditarGrupos from '@/views/Personas/EditarGrupos.vue'
import CrearGrupos from '@/views/Personas/CrearGrupos.vue'
import PanelAdmin from '@/views/PanelAdmin.vue'
import MisRespuestasFormulario from '@/views/Formularios/MisRespuestasFormulario.vue'
import InstructivosPage from '@/views/InstructivosPage.vue'
import CompletarDatosBasicos from '@/views/CompletarDatosBasicos.vue'
import NewsPage from '@/views/Embebidos/NewsPage.vue'
import ErrorServer from '@/views/ErrorServer.vue'
import ReservaEspacios from '@/views/Embebidos/ReservaEspacios.vue'
import FiduPage from '@/views/Fidu/FiduPage.vue'
import InventarioPage from '@/views/Embebidos/InventarioPage.vue'
import MapasAprendizaje from '@/views/Embebidos/MapasAprendizaje.vue'
import EditarPermisos from '@/views/Personas/EditarPermisos.vue'
import CrearPermisos from '@/views/Personas/CrearPermisos.vue'

const routes: Array<RouteRecordRaw> = [
    { path: '/', component: HomePage },
    { path: '/login', component: LogIn },
    { path: '/messageBox', component: MessageBox },
    { path: '/formularios', component: MisFormularios },
    { path: '/formularios/crear', component: CrearFormulario },
    { path: '/formularios/edit', component: EditFormulario },
    { path: '/formularios/completar', component: CompletarFormulario },
    { path: '/formularios/responder', component: ResponderFormulario },
    { path: '/formularios/ver', component: VerFormulario },
    { path: '/formularios/misRespuestas', component: MisRespuestasFormulario },
    { path: '/omeka', component: OmekaPage },
    { path: '/personas', component: PersonasPage },
    { path: '/beneficios', component: BeneficiosPage },
    { path: '/galeria', component: GaleriaPage },
    { path: '/perfil', component: VerPerfil },
    { path: '/personas/verDatosPersona', component: VerDatosPersona },
    { path: '/personas/editarRoles', component: EditarRoles },
    { path: '/personas/crearRoles', component: CrearRoles },
    { path: '/exportadoresPage', component: ExportadoresPage },
    { path: '/formularios/autorizar', component: AutorizarFormulario },
    { path: '/resultadosAcademicos', component: ResultadosAcademicos },
    { path: '/menus', component: MenuPage },
    { path: '/personas/agregarPersona', component: AgregarPersona },
    { path: '/personas/editarGrupos', component: EditarGrupos },
    { path: '/personas/crearGrupos', component: CrearGrupos },
    { path: '/panelAdmin', component: PanelAdmin },
    { path: '/instructivos', component: InstructivosPage },
    { path: '/completarDatosBasicos', component: CompletarDatosBasicos },
    { path: '/noticias', component: NewsPage },
    { path: '/reserva-espacios', component: ReservaEspacios },
    { path: '/error', component: ErrorServer },
    { path: '/fidu', component: FiduPage },
    { path: '/inventario', component: InventarioPage },
    { path: '/mapasAprendizaje', component: MapasAprendizaje },
    { path: '/personas/editarPermiso', component: EditarPermisos },
    { path: '/personas/crearPermiso', component: CrearPermisos },
]

const router = createRouter({
    history: createWebHashHistory(), // Cambia a createWebHashHistory
    //history: createWebHistory(process.env.BASE_URL),
    routes
})

// Guardar el parámetro `message` antes de navegar
router.afterEach((to) => {
    const messageTemp = to.query.message;
    if ((messageTemp)&&messageTemp!='') {
        let message = '';

        if (Array.isArray(messageTemp)) {
            message = messageTemp[0] || '';
        } else {
            message = messageTemp;
        }
        if (message) {
            localStorage.setItem('message', message);
        }
    }
    const redirectTemp = to.query.redirect;
    if ((redirectTemp)&&redirectTemp!='') {
        let redirect = '';

        if (Array.isArray(redirectTemp)) {
            redirect = redirectTemp[0] || '';
        } else {
            redirect = redirectTemp;
        }
        if (redirect) {
            localStorage.setItem('redirect', redirect);
        }
    }
    const tokenTemp = to.query.token;
    if ((tokenTemp)&&tokenTemp!='') {
        let token = '';

        if (Array.isArray(tokenTemp)) {
            token = tokenTemp[0] || '';
        } else {
            token = tokenTemp;
        }
        if (token) {
            localStorage.setItem('passToken', token);
        }
    }
    const idFormTemp = to.query.idForm;
    if ((idFormTemp)&&idFormTemp!='') {
        let idForm = '';

        if (Array.isArray(idFormTemp)) {
            idForm = idFormTemp[0] || '';
        } else {
            idForm = idFormTemp;
        }
        if (idForm) {
            localStorage.setItem('idForm', idForm);
        }
    }
    const idSubmitTemp = to.query.idSubmit;
    if ((idSubmitTemp)&&idSubmitTemp!='') {
        let idSubmit = '';

        if (Array.isArray(idSubmitTemp)) {
            idSubmit = idSubmitTemp[0] || '';
        } else {
            idSubmit = idSubmitTemp;
        }
        if (idSubmit) {
            localStorage.setItem('idSubmit', idSubmit);
        }
    }
    const idNivelTemp = to.query.idNivel;
    if ((idNivelTemp)&&idNivelTemp!='') {
        let idNivel = '';

        if (Array.isArray(idNivelTemp)) {
            idNivel = idNivelTemp[0] || '';
        } else {
            idNivel = idNivelTemp;
        }
        if (idNivel) {
            localStorage.setItem('idNivel', idNivel);
        }
    }
    const idContenidoTemp = to.query.idContenido;
    if ((idContenidoTemp)&&idContenidoTemp!='') {
        let idContenido = '';

        if (Array.isArray(idContenidoTemp)) {
            idContenido = idContenidoTemp[0] || '';
        } else {
            idContenido = idContenidoTemp;
        }
        if (idContenido) {
            localStorage.setItem('idContenido', idContenido);
        }
    }
    const idTemp = to.query.id;
    if ((idTemp)&&idTemp!='') {
        let id = '';

        if (Array.isArray(idTemp)) {
            id = idTemp[0] || '';
        } else {
            id = idTemp;
        }
        if (id) {
            localStorage.setItem('id', id);
        }
    }
});


export default router
